import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [show, setShow] = useState(false);
  return (
    <>
      {/* Nav section  */}
      <section className="nav-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <div className="nav-all">
                <ul>
                  <li className="road-nav">
                    <Link to="/">HOME</Link>
                  </li>
                  <li>
                    <Link to="/About">  ABOUT </Link>
                  </li>
                  {/* <li>
                    <Link to="/meet">MEET THE CREATORS</Link>
                  </li> */}
                  <li>
                    <Link to="/Roadmap">ROADMAP</Link>
                  </li>
                  <li className="no-border">
                    <Link to="/Whitepaper">Whitepaper</Link>
                  </li>
                  {/* <li>
                    <Link to="/Versegame">GOD-VERSE</Link>
                  </li> */}
                  {/* <li>
                    <Link to="/">MINT</Link>
                  </li> */}
                  {/* <li className="no-border faq-nav">
                    <Link to="/Faq">FAQ</Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="canvas-icon animation">
            <button onClick={() => setShow(true)}>
              <i class="fa fa-connectdevelop" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </section>
      {/* End of Nav section  */}

      <div className={show ? "mobile-header show" : "mobile-header"}>
        <div className="cancel">
          <button onClick={()=> setShow(false)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="currentColor"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
          </svg>
          </button>
        </div>
        <ul className="mobile-nav">
          <li className="nav-item">
          <Link to="/">HOME</Link>
            
          </li>
          <li className="nav-item">
            <Link to="/About">ABOUT</Link>
          </li>
          {/* <li className="nav-item">
            <Link to="/meet">MEET THE CREATORS</Link>
          </li> */}
          <li className="nav-item">
          <Link to="/Roadmap">ROADMAP</Link>
          </li>
          <li className="nav-item">
            <Link to="/Whitepaper">WHITEPAPER</Link>
          </li>
          {/* <li className="nav-item">
            <Link to="/Versegame">GOD-VERSE</Link>
          </li> */}
          {/* <li className="nav-item">
            <Link to="/">MINT</Link>
          </li> */}
        </ul>
      </div>
    </>
  );
};

export default Header;
